// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__11kAQ","linkRequests":"styles_linkRequests__JvTz1"};